import React from "react";
import Card from "./Card";
import Image from "./Image";
import ScrollToTop from "./utils/ScrollToTop";
import imageOfficeWorking from "../images/office-working.png";

function SubmittingCard({
  title = "Submitting your details",
  text = "Please wait while we save your information.",
  showImage = true,
}) {
  return (
    <React.Fragment>
      <ScrollToTop />
      <div role="status" aria-live="polite">
        <Card title={title} removeTopPadding>
          <p>{text}</p>
        </Card>
        {showImage && <Image src={imageOfficeWorking} alt="" fullWidth />}
      </div>
    </React.Fragment>
  );
}

export default SubmittingCard;
